export default __webpack_public_path__ + "static/media/logo-2.f0327081.svg";